import { type ReactNode, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSegment } from '@repo/poly-hooks/segment';
import { Cogwheels, Rejected } from '../../svgs';
import styles from './fraud.module.css';

export function FraudSuspicion(): ReactNode {
  const segment = useSegment();

  useEffect(() => {
    segment.track('onboarding_idnow_fraud_suspicion_screen_loaded');
  }, [segment]);

  return (
    <div className={styles.wrapper} data-test-idnow-step-fraud-suspicion>
      <div className={styles.container} data-test-idnow-fraud-suspicion-step>
        <div className="mb-32">
          <Cogwheels className={styles.icon} />
        </div>
        <h1 className="heading-section mb-16">
          <FormattedMessage id="qonto-idnow.fraud-suspicion.title" />
        </h1>
        <p className="body-standard">
          <FormattedMessage id="qonto-idnow.fraud-suspicion.subtitle" />
        </p>
      </div>
    </div>
  );
}

export function FraudConfirmed(): ReactNode {
  const segment = useSegment();

  useEffect(() => {
    segment.track('onboarding_idnow_fraud_suspicion_confirmed');
  }, [segment]);

  return (
    <div className={styles.wrapper} data-test-idnow-step-fraud-confirmed>
      <div className={styles.container} data-test-idnow-fraud-confirmed-step>
        <div className="mb-32">
          <Rejected className={styles.icon} />
        </div>
        <h1 className="heading-section mb-16" data-test-idnow-fraud-confirmed-step-title>
          <FormattedMessage
            id="qonto-idnow.video-ident-rejected.title"
            values={{ provider: 'IDNow' }}
          />
        </h1>
        <p className="body-standard" data-test-idnow-fraud-confirmed-step-subtitle>
          <FormattedMessage id="qonto-idnow.video-ident-rejected.subtitle" />
        </p>
      </div>
    </div>
  );
}
